import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartsModule } from 'ng2-charts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule } from 'ng2-translate';
import { MaterialModule } from '@angular/material';
import { OrganizationsListComponent } from './components/organizations-list/organizations-list.component';
import { OrganisationsComponent } from './organisations.component';
import { AddCompanyComponent } from './components/add-company/add-company.component';
import { DeleteCompanyComponent } from './components/delete-company/delete-company.component';


@NgModule({
  imports: [
    CommonModule,
    ChartsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    TranslateModule.forRoot()
  ],
  declarations: [
    OrganisationsComponent,
    OrganizationsListComponent,
    AddCompanyComponent,
    DeleteCompanyComponent
  ],
  exports: [
    OrganisationsComponent
  ],
  entryComponents: [
    AddCompanyComponent,
    DeleteCompanyComponent
  ]
})
export class OrganisationsModule { }



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/organisations/organisations.module.ts